import {UcoastEl} from "@/scripts/core/UcoastEl"
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class ProductCard extends UcoastEl {
  static htmlSelector = 'product-card'

  colors: undefined | NodeListOf<HTMLElement>
  images: undefined | NodeListOf<HTMLElement>

  constructor() {
    super()

    this.colors = q.ol('[data-uc-product-variant-color]', this)
    this.images = q.ol('[data-uc-product-variant-image]', this)

    if (this.colors && this.colors.length) {
      this.colors.forEach(color => color.addEventListener('click', this.activateImage.bind(this)))
      this.colors[0].click()
    }
  }

  activateImage(event: Event) {
    const target = q.rt<Event, HTMLElement>(event)

    const selected = q.oa(target, 'data-uc-product-variant-color')

    if (this.images) {
      this.images.forEach(image => {
        const item = q.oa(image, 'data-uc-product-variant-image')

        image.classList.toggle('active', selected === item)
      })
    }
  }
}
